import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ICompany} from '../models/ICompany';
import {ILocation} from '../models/ILocation';

export interface ICompaniesResponse {
  currentPage: number;
  resultsPerPage: number;
  totalPages: number;
  totalResults: number;
  items: ICompany[];
  isEmpty: true;
  isNotEmpty: true;
}

export interface ICompaniesMembers {
  email: string;
  firstName: string;
  isInvitationAccepted: boolean;
  lastName: string;
  memberId: string;
  phone: string;
  role: string;
  title: string;
}

export interface ICompaniesMembersResponse {
  currentPage: number;
  resultsPerPage: number;
  totalPages: number;
  totalResults: number;
  items: ICompaniesMembers[];
  isEmpty: true;
  isNotEmpty: true;
}

export interface ILocationsResponse {
  currentPage: number;
  resultsPerPage: number;
  totalPages: number;
  totalResults: number;
  items: ILocation[];
  isEmpty: true;
  isNotEmpty: true;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(
    private http: HttpClient
  ) {
  }

  public getCompanies(): Observable<ICompaniesResponse> {
    return this.http.get<ICompaniesResponse>(`${environment.apiUrl}/companies`, {
      params: {
        page: '0',
        resultsPerPage: '9999'
      }
    });
  }

  public getCompanyMembers(companyId: string): Observable<ICompaniesMembers[]> {
    return this.http.get<ICompaniesMembers[]>(`${environment.apiUrl}/companies/${companyId}/members`, {
      params: {
        page: '0',
        resultsPerPage: '9999'
      }
    });
  }

  public getCompanyLocations(id: string, reservationEnabled: boolean): Observable<ILocationsResponse> {
    return this.http.get<ILocationsResponse>(`${environment.apiUrl}/companies/${id}/locations`, {
      params: {
        companyId: id,
        reservationEnabled: `${reservationEnabled}`,
        page: '0',
        resultsPerPage: '9999'
      }
    });
  }

  public getCompany(id: string): Observable<ICompany> {
    return this.http.get<ICompany>(`${environment.apiUrl}/company/${id}`);
  }

  public async getAvailableLocations(reservationEnabled?: boolean): Promise<ILocation[]> {
    const companies = await this.getCompanies().toPromise();

    if (companies && companies.items.length > 0) {
      const locations = await this.getCompanyLocations(companies.items[0].id, reservationEnabled).toPromise();

      return locations.items;
    }
    return [];
  }
}
